import React, { Fragment } from 'react';
import { getCategoryUrl, getSubcategoryUrl } from '../../utilities/urlHelper';
import { CategoryIcon, FolderIcon } from './CategoryFolderTitle';
import { EVENTS } from '../../utilities/CONSTANTS';

class PageCategoryTitle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (!window.categoriesAndFoldersMap) {
            window.addEventListener(EVENTS.CATEGORIES_LOADED, () => this.forceUpdate());
        }
    }

    componentWillUnmount() { return window.removeEventListener(EVENTS.CATEGORIES_LOADED, () => this.forceUpdate()); }

    render() {
        const { categoryId, folderId, parents } = this.props;

        if (!categoryId || !window.categoriesAndFoldersMap || !window.categoriesAndFoldersMap[categoryId]) return null;

        let folderName; let folderIcon; let
            folderColor;
        const categoryName = window.categoriesAndFoldersMap[categoryId].name;
        const { icon } = window.categoriesAndFoldersMap[categoryId];
        const { color } = window.categoriesAndFoldersMap[categoryId];

        if (folderId) {
            folderName = window.categoriesAndFoldersMap[categoryId].folders[folderId].name;
            folderIcon = window.categoriesAndFoldersMap[categoryId].folders[folderId].icon;
            folderColor = window.categoriesAndFoldersMap[categoryId].folders[folderId].color;
        }

        const parentsDropdown = parents.map((parent) => (
            <a href={getSubcategoryUrl(parent.id)} className="dropdown-option" key={`breadcrumb-${parent.id}`}>
                <FolderIcon icon={parent.icon} color={parent.color} className="mr1 rounded left" />
                {parent.name}
            </a>
        ));

        return (
            <Fragment>
                {
                    categoryName
                    && (
                        <a className="breadcrumb-link" href={getCategoryUrl(categoryId)} title={categoryName}>
                            <CategoryIcon icon={icon} color={color} className="mr1 rounded left" />
                            {categoryName}
                        </a>
                    )
                }
                {
                    parentsDropdown.length > 0
                    && (
                        <Fragment>
                            <span className="breadcrumb-separator">/</span>
                            <div className="dropdown dropdown-left-aligned" data-disclosure>
                                <button className="breadcrumb-link dropdown-link dropdown-elipsis" type="button">
                                ...
                                </button>
                                <div data-details className="dropdown-overlay" style={{ display: 'none' }} />
                                <div data-details className="dropdown-content" style={{ display: 'none' }}>
                                    {parentsDropdown}
                                </div>
                            </div>
                        </Fragment>
                    )
                }
                {
                    folderName
                    && (
                        <Fragment>
                            <span className="breadcrumb-separator">/</span>
                            <a className="breadcrumb-link" href={getSubcategoryUrl(folderId)} title={folderName}>
                                <FolderIcon icon={folderIcon} color={folderColor} className="mr1 rounded left" />
                                {folderName}
                            </a>
                        </Fragment>
                    )
                }
            </Fragment>
        );
    }
}

export default PageCategoryTitle;
